import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorks from './components/HowItWorks';
import DemoSection from './components/DemoSection';
import Footer from './components/Footer';

function App() {
  // Default is true (dark theme)
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    // Update meta description dynamically
    document.title = 'CivilCADPro - Survey Toolkit for AutoCAD | Contouring, Volume Calculation';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'CivilCADPro is the ultimate AutoCAD plugin for surveyors. Generate contour maps, calculate volumes, convert KML⇄CAD. Book a free demo!');
    }
    
    // Apply theme
    if (darkMode) {
      document.body.style.backgroundColor = '#0F172A';
      document.body.style.color = '#F8FAFC';
    } else {
      document.body.style.backgroundColor = '#F8FAFC';
      document.body.style.color = '#0F172A';
    }
  }, [darkMode]);

  return (
    <div className={`App ${darkMode ? 'dark-mode' : ''}`}>
      <header>
        <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
      </header>
      
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorks />
        <DemoSection />
      </main>
      
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;